import { ArtistDTO } from "~/types/artist";

import { cn } from "../utils";

import { UserArtistTile } from "./UserArtistTile";

interface Props {
  artists: ArtistDTO[];
  isCurrentUser: boolean;
  isMatch: boolean;
  matchArtists?: ArtistDTO[];
}

export function UserArtistGrid({
  artists,
  isCurrentUser,
  isMatch,
  matchArtists,
}: Props) {
  const isBlurred = !isCurrentUser && !isMatch;

  return (
    <div className="relative">
      {isBlurred ? (
        <div className="absolute z-10 w-full h-full flex items-center justify-center text-white">
          not a match :(
        </div>
      ) : null}
      <div className={cn("grid grid-cols-4 gap-2", isBlurred && "blur")}>
        {artists.map((artist) => (
          <UserArtistTile
            key={artist.id}
            artist={artist}
            isCurrentUser={isCurrentUser}
            isCommon={
              matchArtists
                ? matchArtists.some((a) => a.id === artist.id)
                : false
            }
          />
        ))}
      </div>
    </div>
  );
}
